


































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { exportToCSV, DatabaseHeader } from './admin/tables/database';

import Plotly from 'src/misc/external/plotly';


@Component
export default class BarPlotWrapperObject extends Vue {
  $refs: {
    plotRef: HTMLElement
  }

  compareLabels      =  ['BCT (N)', 'Weight (g/m²)', 'Thickness (mm)', 'ECT (kN/m)', 'Bend. Stiff. MD (Nm)', 'Bend. Stiff. CD (Nm)', 'Burst (kPa)'];
  compareValueLabels =  [    'bct',      'grammage',      'thickness',        'ect', 'bending_stiffness_MD', 'bending_stiffness_CD',       'burst'];

  get boards() {
    return this.$store.state.currentProject.boards;
  }

  get appMenuMini() {
    return this.$store.state.appMenuMini;
  }

  get card() {
    return this.$store.getters.getCard('GraphsCard');
  }

  @Watch('boards', { deep: true })
  onBoardsChanged() {
    Plotly.purge(this.$refs.plotRef);
    this.redrawPlots();
  }

  @Watch('appMenuMini')
  onAppMenuMiniChanged() {
    this.handleResizeDelayed();
  }

  @Watch('card', { deep: true })
  onCardChanged() {
    this.handleResizeDelayed();
  }

  mounted() {
    this.redrawPlots();
    window.addEventListener('resize', this.handleResize);

    this.handleResizeDelayed();
  }

  onExport() {
    let headers: DatabaseHeader[] = [{
      text: "Name",
      value: "board",
    }];
    let values = [];

    for (let i = 0; i < this.compareValueLabels.length; i++) {
      headers.push({
        text: this.compareLabels[i],
        value: this.compareValueLabels[i],
      });
    }

    for (let j = 0; j < this.boards.length; j++) {
      let board = this.boards[j];

      if (!board.visible ||
          !board.hasBoardResults() ||
          board.hasSimulationErrors())
        continue;

      let row = {
        board: board.name,
      };


      for (let i = 0; i < this.compareValueLabels.length; i++) {
        let compareValueLabel = this.compareValueLabels[i];
        if (compareValueLabel == 'bct' && !board.hasSimulationSuccess())
          row[compareValueLabel] = '-';
        else
          row[compareValueLabel] = board.simulationResults[0][compareValueLabel];
      }

      values.push(row);
    }

    exportToCSV('Board-Box-Properties', headers, values);
  }

  redrawPlots() {
    var compareValueFormats = [    '.0f',           '.0f',            '.2f',        '.2f',                  '.2f',                  '.2f',         '.0f'];
    var theme: any = this.$vuetify.theme;

    var themeColors = [
      theme.boardColor1,
      theme.boardColor2,
      theme.boardColor3,
      theme.boardColor4,
      theme.boardColor5,
      theme.boardColor6,
      theme.boardColor7,
      theme.boardColor1,
      theme.boardColor2,
      theme.boardColor3,
      theme.boardColor4,
      theme.boardColor5,
      theme.boardColor6,
      theme.boardColor7
    ]

    var data = [];

    var layout = {
      margin: { l: 60 },
      title: {
        text: 'Board and Box Properties',
      },
      showlegend: false
    }

    let padding = 0.04;
    var currentPosition = 0.0;
    let figureWidth = (1 - (this.compareLabels.length - 1) * padding) / this.compareLabels.length;

    for (let i = 0; i < this.compareValueLabels.length; i++) {
      let compareValueLabel = this.compareValueLabels[i];
      let compareLabel = this.compareLabels[i];
      let axisIndex = i + 1;

      for (let j = 0; j < this.boards.length; j++) {
        let board = this.boards[j];

        if (!board.visible ||
            !board.hasBoardResults() ||
            board.hasSimulationErrors() ||
            (compareValueLabel == 'bct' && !board.hasSimulationSuccess()))
          continue;


        var trace = {
          x: [ compareLabel ],
          y: [ board.simulationResults[0][compareValueLabel] ],
          xaxis: 'x' + axisIndex,
          yaxis: 'y' + axisIndex,
          marker:{
            color: [ themeColors[j] ],
          },
          hoverinfo:"y",
          type: 'bar',
          name: board.name,
        };

        data.push(trace);
      }

      layout['yaxis' + axisIndex] = {
        hoverformat: compareValueFormats[i],
        fixedrange: true,
        anchor: 'x' + axisIndex,
      };

      layout['xaxis' + axisIndex] = {
        fixedrange: true,
        domain: [currentPosition, currentPosition + figureWidth],
      };

      currentPosition += figureWidth + padding;
    }

    var config = {
      displayModeBar: false
    };

    Plotly.plot(this.$refs.plotRef, data, layout, config);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResizeDelayed() {
    setTimeout(() => {
      this.handleResize();
    }, 200);
  }

  handleResize() {
    Plotly.purge(this.$refs.plotRef);
    this.redrawPlots();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BarPlotWrapperObject.vue